/* tslint:disable */
/* eslint-disable */
export enum WorkDataQualityCheckType {
  ProjectInstallationDatesReversed = 'PROJECT_INSTALLATION_DATES_REVERSED',
  TaskDatesReversed = 'TASK_DATES_REVERSED',
  TaskMissingProjectAndTeam = 'TASK_MISSING_PROJECT_AND_TEAM',
  TaskAppointmentOneDateMissing = 'TASK_APPOINTMENT_ONE_DATE_MISSING',
  TaskDuplicateByProjectAndDate = 'TASK_DUPLICATE_BY_PROJECT_AND_DATE',
  TaskInstallationDatesNotSynced = 'TASK_INSTALLATION_DATES_NOT_SYNCED'
}
